export default __webpack_public_path__ + "static/media/logo.5e68a829.png";